import React, { useEffect, useState } from 'react'
import { string, bool, element, func } from 'prop-types'
import { Button } from '@livechat/design-system-react-components'

import {
  installTrustedApp,
  installTrustedAppNotLoggedIn,
} from '@/store/installedApps'
import {
  canInstallApplications,
  hasInstallationProcessError,
  isAuthorized,
} from '@/store/selectors'
import { useTypedDispatch, useTypedSelector } from '@/store/hooks'
import auth from '@/utils/auth'

/*
  Custom flow for installing internal products (HelpDesk, KnowledgeBase, ChatBot,...)
  without directInstallUrl, all logic from the directInstallUrl is moved to the backend
*/
export const TrustedProductButton = ({
  id,
  icon,
  size,
  disabled,
  className,
  fullWidth,
  redirect = true,
}) => {
  const dispatch = useTypedDispatch()
  const isAuth = useTypedSelector(isAuthorized)
  const hasInstallationError = useTypedSelector(hasInstallationProcessError)
  const canInstallApplication = useTypedSelector(canInstallApplications)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (hasInstallationError) {
      setIsLoading(false)
    }
  }, [hasInstallationError])

  const handleClick = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    if (isAuth) {
      if (canInstallApplication) {
        dispatch(installTrustedApp.pending({ id, redirect }))
      }
    } else {
      dispatch(installTrustedAppNotLoggedIn({ id, redirect }))
      auth.signIn()
    }
  }

  return (
    <Button
      data-test="install-btn"
      kind="primary"
      icon={icon || ''}
      size={size}
      loading={isLoading}
      disabled={disabled}
      onClick={handleClick}
      className={className}
      fullWidth={fullWidth}
    >
      Get
    </Button>
  )
}

TrustedProductButton.propTypes = {
  className: string,
  icon: element,
  size: string,
  disabled: bool,
  id: string,
  installApp: func,
  fullWidth: bool,
  redirect: bool,
}

export default TrustedProductButton
